var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2Satellite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1705_25966)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.26073 1.26625C0.745789 1.7812 0.690678 2.58182 1.09534 3.15797L3.15246 1.10085C2.57631 0.696197 1.77568 0.751295 1.26073 1.26625Z",
    fill: "#787A85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.1563 2.4456L4.84248 2.75942L3.40861 1.32556L1.32013 3.41406L2.75399 4.84793L2.44557 5.15635L2.79673 5.5075L3.10514 5.19908L3.28787 5.38181C3.37877 5.47271 3.52617 5.47271 3.61708 5.38181L4.32115 4.67774L4.63342 4.99003C4.31287 5.43044 4.24757 5.99878 4.43762 6.49129C4.47819 6.59644 4.61286 6.62588 4.69255 6.54618L5.46436 5.77436L5.64923 5.95922C5.73333 6.04331 5.86967 6.04331 5.95376 5.95922C6.03786 5.87513 6.03786 5.73879 5.95376 5.65469L5.7689 5.46982L6.54072 4.69801C6.62042 4.61831 6.59098 4.48364 6.48583 4.44308C5.99333 4.25303 5.42498 4.31835 4.98457 4.63888L4.67229 4.32661L5.37635 3.62254C5.46725 3.53164 5.46725 3.38425 5.37635 3.29334L5.19362 3.11061L5.50744 2.79679L5.1563 2.4456Z",
    fill: "#787A85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0681825 6.9584L1.03386 7.92408C1.07931 7.96953 1.13889 7.99226 1.19846 7.99226C1.25803 7.99226 1.31761 7.96954 1.36306 7.92408L2.94324 6.34389C3.03414 6.25299 3.03414 6.10561 2.94324 6.01469L2.61638 5.68783L2.26523 5.33668L1.97757 5.04902C1.93212 5.00355 1.87254 4.98083 1.81297 4.98083C1.7534 4.98083 1.69382 5.00355 1.64837 5.04902L0.0681825 6.62919C-0.0227326 6.7201 -0.0227326 6.86749 0.0681825 6.9584Z",
    fill: "#787A85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.93182 1.04167L6.96614 0.0759955C6.92069 0.0305445 6.86111 0.0078125 6.80154 0.0078125C6.74197 0.0078125 6.68239 0.0305315 6.63694 0.0759955L5.05676 1.65618C4.96586 1.74708 4.96586 1.89447 5.05676 1.98538L5.33665 2.26528L5.68782 2.61643L6.02243 2.95105C6.06788 2.99652 6.12747 3.01924 6.18703 3.01924C6.2466 3.01924 6.30618 2.99652 6.35163 2.95105L7.93182 1.37087C8.02272 1.27997 8.02272 1.13257 7.93182 1.04167Z",
    fill: "#787A85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.77069 6.27387V6.65645C6.25612 6.65645 6.65102 6.26153 6.65102 5.77612H6.26844C6.26844 6.05058 6.04515 6.27387 5.77069 6.27387Z",
    fill: "#787A85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.73928 7.30726C6.60085 7.30726 7.30179 6.60632 7.30179 5.74475H6.91922C6.91922 6.39641 6.39094 6.92469 5.73928 6.92469V7.30726Z",
    fill: "#787A85"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1705_25966"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2Satellite);
export default __webpack_public_path__ + "static/media/2_satellite.3d189c65d3b4cbea9d27ecda523780d7.svg";
export { ForwardRef as ReactComponent };